import React, { Fragment, useState } from "react";
import ReactEmoji from "react-emoji";

import CampaignChatLogo from "../Campaign/CampaignChatLogo";

const MessageChatItemMini = ({
  user,
  profile,
  message,
  deleteMessage,
  isAuthenticated,
  TimeOut,
  setShowReportUser,
  setReportedUser,
  setShowBanUser,
  setBannedUser,
  moderators,
  moderate,
  deleteModerator,
  timeoutDeleteMessage,
  messages,
  notifications,
  setNotifications,
  xFalse,
}) => {
  const [showModal, setShowModal] = useState(false);

  const removeNotification = (notifications, message) => {
    setNotifications([
      ...notifications.filter(
        (notification) =>
          notification.messageid.toString() !== message.messageid.toString()
      ),
    ]);
  };

  return (
    <Fragment>
      {message && message.type === "message" && (
        <div className="full-message-body">
          {message &&
            message.firstMessage &&
            user.channelid === profile.channelid && (
              <span
                className={`max-text-width-notification ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <i
                  className={`fa-regular fa-message ${
                    user && user.role === "innovator"
                      ? "green"
                      : user && user.role === "mentor"
                      ? "red"
                      : user && user.role === "employer"
                      ? "blue"
                      : ""
                  } mr-10 mb-10 margin-top-fifteen`}
                ></i>
                {"First Chat Message"}
              </span>
            )}
          {message.mentions &&
            message.mentions.length > 0 &&
            message.mentions.map((x) => {
              if (x === user.channelid) {
                return (
                  <span
                    className={`max-text-width-notification ${
                      user && user.role === "innovator"
                        ? "green"
                        : user && user.role === "mentor"
                        ? "red"
                        : user && user.role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  >
                    <i
                      className={`fa-solid fa-bullhorn ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      } mr-10 mb-10 margin-top-fifteen`}
                    ></i>
                    {"Mention"}
                  </span>
                );
              }
            })}
          <div
            className={`chat-body-mini ${
              message.mentions && message.mentions.length > 0
                ? message.mentions.map((x) => {
                    if (x === user.channelid && user.role === "innovator") {
                      return "green";
                    } else if (x === user.channelid && user.role === "mentor") {
                      return "red";
                    } else if (
                      x === user.channelid &&
                      user.role === "employer"
                    ) {
                      return "blue";
                    } else {
                      return "grey";
                    }
                  })
                : "grey"
            }`}
          >
            <div className="chat-container">
              <div className="chat-user-container">
                <div className="chat-item-containers">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${message.avatar}`}
                    className="chat-avi"
                    alt="chatimage"
                  />
                </div>
                <div className="chat-item-containers">
                  <div className="chat-text-mini">
                    <span
                      className={`${
                        profile && profile.role === "innovator"
                          ? "green"
                          : profile && profile.role === "mentor"
                          ? "red"
                          : profile && profile.role === "employer"
                          ? "blue"
                          : ""
                      } mr-5 chat-logo-align`}
                    >
                      {message.firstname === "imeBOT" ? (
                        <i className="fa-solid fa-robot chat-logo-mini"></i>
                      ) : message.founding_supporter_type === "Overwhelming" ? (
                        <CampaignChatLogo />
                      ) : (
                        ""
                      )}
                      {profile.channelid === message.channelid &&
                        isAuthenticated && (
                          <i className="fa-solid fa-crown fa-sm gold mr-5"></i>
                        )}
                      {moderators.map((mod) => {
                        if (mod.channelid === message.channelid) {
                          return (
                            <i
                              className={`fa-solid fa-screwdriver-wrench fa-sm ${
                                message && message.role === "innovator"
                                  ? "green"
                                  : message && message.role === "mentor"
                                  ? "red"
                                  : message && message.role === "employer"
                                  ? "blue"
                                  : ""
                              } mr-5`}
                            ></i>
                          );
                        }
                      })}
                      {message.founding_supporter_type === "Good" &&
                        isAuthenticated &&
                        message.firstname !== "imeBOT" && (
                          <i className="fa-solid fa-1 fa-sm gold mr-5"></i>
                        )}
                      {message.founding_supporter_type === "Great" &&
                        isAuthenticated &&
                        message.firstname !== "imeBOT" && (
                          <i className="fa-solid fa-1 fa-sm gold mr-5"></i>
                        )}
                      {message.founding_supporter_type === "Overwhelming" &&
                        isAuthenticated &&
                        message.firstname !== "imeBOT" && (
                          <div>
                            <i className="fa-solid fa-star fa-sm gold mr-5"></i>
                            <i className="fa-solid fa-1 fa-sm gold mr-5"></i>
                          </div>
                        )}
                      {message.verified && (
                        <div>
                          <i
                            className={`fa-regular fa-circle-check fa-sm ${
                              message && message.role === "innovator"
                                ? "green"
                                : message && message.role === "mentor"
                                ? "red"
                                : message && message.role === "employer"
                                ? "blue"
                                : ""
                            } mr-5`}
                          ></i>
                        </div>
                      )}
                      <span
                        className={` ${
                          message.founding_supporter_type === "Overwhelming"
                            ? "change-name-color"
                            : message && message.role === "innovator"
                            ? "green"
                            : message && message.role === "mentor"
                            ? "red"
                            : message && message.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      >
                        {message.firstname === "imeBOT"
                          ? message.firstname
                          : message.channelid}{" "}
                      </span>
                      :{" "}
                    </span>
                    <span
                      className={`${
                        message.deleted
                          ? "italicized red"
                          : message.timedout
                          ? "italicized red"
                          : "max-text-width-mini"
                      } 
                  `}
                    >
                      {ReactEmoji.emojify(message.text)}
                    </span>
                    {message.gif !== "" && (
                      <img
                        src={message.gif}
                        alt="avatar"
                        className="gif-image"
                      />
                    )}
                  </div>
                </div>
              </div>
              {message.firstname !== "imeBOT" &&
                !message.deleted &&
                !message.timedout &&
                !showModal && (
                  <div className="chat-item-modal-containers">
                    <div className="chat-user-info">
                      <i
                        onClick={() => {
                          if (showModal) {
                            setShowModal(false);
                          } else {
                            setShowModal(true);
                          }
                        }}
                        className="fas fa-ellipsis-v mx-10 red cursor"
                      ></i>
                    </div>
                  </div>
                )}
            </div>
            <div className="center">
              {message.firstname !== "imeBOT" &&
                !message.deleted &&
                showModal &&
                isAuthenticated && (
                  <div className="chat-item-modal-containers">
                    <div className="chat-modal">
                      <ul className="modal-items">
                        {user.channelid === profile.channelid &&
                          showModal &&
                          moderators &&
                          moderators.length > 0 &&
                          moderators.map((mod) => {
                            if (mod.channelid === message.channelid) {
                              return (
                                <li
                                  onClick={() => {
                                    deleteModerator(message.channelid);
                                    setShowModal(false);
                                  }}
                                  className="modal-item"
                                >
                                  <i
                                    className={`fa-solid fa-screwdriver mx-5 ${
                                      profile && profile.role === "innovator"
                                        ? "green"
                                        : profile && profile.role === "mentor"
                                        ? "red"
                                        : profile && profile.role === "employer"
                                        ? "blue"
                                        : ""
                                    }`}
                                  ></i>
                                  Delete Mod
                                </li>
                              );
                            } else if (
                              mod.channelid !== "" &&
                              mod.channelid !== message.channelid
                            ) {
                              return null;
                            }
                          })}
                        {showModal &&
                          moderators.length <= 0 &&
                          user.channelid === profile.channelid &&
                          message.channelid !== profile.channelid && (
                            <li
                              onClick={() => {
                                moderate(message.channelid);
                                setShowModal(false);
                              }}
                              className="modal-item"
                            >
                              <i
                                className={`fa-solid fa-wrench mx-5 ${
                                  profile && profile.role === "innovator"
                                    ? "green"
                                    : profile && profile.role === "mentor"
                                    ? "red"
                                    : profile && profile.role === "employer"
                                    ? "blue"
                                    : ""
                                }`}
                              ></i>
                              Moderate
                            </li>
                          )}
                        {user.channelid === profile.channelid &&
                          showModal &&
                          user.channelid !== message.channelid && (
                            <li
                              onClick={() => {
                                setShowBanUser({
                                  submit: true,
                                  confirm: false,
                                });
                                setBannedUser({
                                  ...setBannedUser,
                                  role: message.role,
                                  channelid: message.channelid,
                                  avatar: message.avatar,
                                  firstname: message.firstname,
                                  lastname: message.lastname,
                                  text: message.text,
                                  image: "",
                                  video: "",
                                  gif: message.gif !== "" ? message.gif : "",
                                  message,
                                  messages,
                                });
                                setShowModal(false);
                              }}
                              className="modal-item"
                            >
                              <i
                                className={`fa-solid fa-ban mx-5 ${
                                  profile && profile.role === "innovator"
                                    ? "green"
                                    : profile && profile.role === "mentor"
                                    ? "red"
                                    : profile && profile.role === "employer"
                                    ? "blue"
                                    : ""
                                }`}
                              ></i>
                              Ban
                            </li>
                          )}
                        {user.channelid === profile.channelid &&
                          showModal &&
                          user.channelid !== message.channelid && (
                            <li
                              onClick={() => {
                                TimeOut(message, profile, messages);
                                timeoutDeleteMessage(message);
                                setShowModal(false);
                              }}
                              className="modal-item"
                            >
                              <i
                                className={`fa-solid fa-hourglass-half mx-5 ${
                                  profile && profile.role === "innovator"
                                    ? "green"
                                    : profile && profile.role === "mentor"
                                    ? "red"
                                    : profile && profile.role === "employer"
                                    ? "blue"
                                    : ""
                                }`}
                              ></i>
                              Timeout
                            </li>
                          )}
                        {user.channelid !== profile.channelid &&
                          showModal &&
                          moderators.map((mod) => {
                            if (
                              mod.channelid === user.channelid &&
                              mod.level === "Senior" &&
                              mod.channelid !== message.channelid
                            ) {
                              return (
                                <li
                                  onClick={() => {
                                    TimeOut(message, profile, messages);
                                    timeoutDeleteMessage(message);
                                    setShowModal(false);
                                  }}
                                  className="modal-item"
                                >
                                  <i
                                    className={`fa-solid fa-hourglass-half mx-5 ${
                                      profile && profile.role === "innovator"
                                        ? "green"
                                        : profile && profile.role === "mentor"
                                        ? "red"
                                        : profile && profile.role === "employer"
                                        ? "blue"
                                        : ""
                                    }`}
                                  ></i>
                                  Timeout
                                </li>
                              );
                            }
                          })}
                        {message.channelid === user.channelid && showModal && (
                          <li
                            onClick={() => {
                              deleteMessage(message, messages);
                              setShowModal(false);
                            }}
                            className="modal-item"
                          >
                            <i
                              className={`fas fa-times mx-5 ${
                                profile && profile.role === "innovator"
                                  ? "green"
                                  : profile && profile.role === "mentor"
                                  ? "red"
                                  : profile && profile.role === "employer"
                                  ? "blue"
                                  : ""
                              }`}
                            ></i>
                            Delete
                          </li>
                        )}
                        {moderators.map((mod) => {
                          if (
                            mod.channelid === user.channelid &&
                            user.channelid !== message.channelid
                          ) {
                            return (
                              <li
                                onClick={() => deleteMessage(message, messages)}
                                className="modal-item"
                              >
                                <i
                                  className={`fas fa-times mx-5 ${
                                    profile && profile.role === "innovator"
                                      ? "green"
                                      : profile && profile.role === "mentor"
                                      ? "red"
                                      : profile && profile.role === "employer"
                                      ? "blue"
                                      : ""
                                  }`}
                                ></i>
                                Delete
                              </li>
                            );
                          }
                        })}
                        {message.channelid !== user.channelid &&
                          user.channelid === "roland" &&
                          showModal && (
                            <li
                              onClick={() => {
                                deleteMessage(message, messages);
                                setShowModal(false);
                              }}
                              className="modal-item"
                            >
                              <i
                                className={`fas fa-times mx-5 ${
                                  profile && profile.role === "innovator"
                                    ? "green"
                                    : profile && profile.role === "mentor"
                                    ? "red"
                                    : profile && profile.role === "employer"
                                    ? "blue"
                                    : ""
                                }`}
                              ></i>
                              Delete
                            </li>
                          )}
                        {message.channelid !== user.channelid && showModal && (
                          <li
                            onClick={() => {
                              setShowReportUser({
                                submit: true,
                                confirm: false,
                              });
                              setReportedUser({
                                role: message.role,
                                channelid: message.channelid,
                                avatar: message.avatar,
                                firstname: message.firstname,
                                lastname: message.lastname,
                                text: message.text,
                                image: "",
                                video: "",
                                gif: message.gif !== "" ? message.gif : "",
                              });
                              setShowModal(false);
                            }}
                            className="modal-item"
                          >
                            <i
                              className={`fas fa-flag mx-5 ${
                                profile && profile.role === "innovator"
                                  ? "green"
                                  : profile && profile.role === "mentor"
                                  ? "red"
                                  : profile && profile.role === "employer"
                                  ? "blue"
                                  : ""
                              }`}
                            ></i>
                            Report
                          </li>
                        )}
                      </ul>
                    </div>
                    <div className="chat-user-info">
                      <i
                        onClick={() => {
                          if (showModal) {
                            setShowModal(false);
                          } else {
                            setShowModal(true);
                          }
                        }}
                        className="fas fa-ellipsis-v mx-10 red cursor"
                      ></i>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      )}
      {message && message.type === "notification" && (
        <div
          className={`notification-body ${
            message && message.role === "innovator"
              ? "green"
              : message && message.role === "mentor"
              ? "red"
              : message && message.role === "employer"
              ? "blue"
              : ""
          }`}
        >
          <div className="chat-container">
            <div className="chat-user-container">
              <div className="chat-item-containers">
                <div className="chat-text-mini">
                  <span
                    className={`max-text-width-notification ${
                      message && message.role === "innovator"
                        ? "green"
                        : message && message.role === "mentor"
                        ? "red"
                        : message && message.role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  >
                    <i className="fa-solid fa-circle-dollar-to-slot green mr-5 mb-10"></i>
                    {message.text} {"\n"}
                  </span>{" "}
                  <span
                    className={`${
                      profile && profile.role === "innovator"
                        ? "green"
                        : profile && profile.role === "mentor"
                        ? "red"
                        : profile && profile.role === "employer"
                        ? "blue"
                        : ""
                    } mr-5 chat-badges`}
                  >
                    {message.founding_supporter_type === "Overwhelming" && (
                      <CampaignChatLogo />
                    )}
                    {profile.channelid === message.channelid &&
                      isAuthenticated && (
                        <i className="fa-solid fa-crown fa-sm gold mr-5"></i>
                      )}
                    {moderators.map((mod) => {
                      if (mod.channelid === message.channelid) {
                        return (
                          <i
                            className={`fa-solid fa-screwdriver-wrench fa-sm ${
                              message && message.role === "innovator"
                                ? "green"
                                : message && message.role === "mentor"
                                ? "red"
                                : message && message.role === "employer"
                                ? "blue"
                                : ""
                            } mr-5`}
                          ></i>
                        );
                      }
                    })}
                    {message.founding_supporter_type === "Good" &&
                      isAuthenticated && (
                        <i className="fa-solid fa-1 fa-sm gold mr-5"></i>
                      )}
                    {message.founding_supporter_type === "Great" &&
                      isAuthenticated && (
                        <i className="fa-solid fa-1 fa-sm gold mr-5"></i>
                      )}
                    {message.founding_supporter_type === "Overwhelming" &&
                      isAuthenticated && (
                        <div>
                          <i className="fa-solid fa-star fa-sm gold mr-5"></i>
                          <i className="fa-solid fa-1 fa-sm gold mr-5"></i>
                        </div>
                      )}
                    <span
                      className={` ${
                        message && message.role === "innovator"
                          ? "green"
                          : message && message.role === "mentor"
                          ? "red"
                          : message && message.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    >
                      {message.channelid}
                      {"\n"}
                    </span>
                  </span>
                  <div className="flex-only-chat">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${message.avatar}`}
                      className="chat-avi"
                      alt="chatimage"
                    />
                    <span className="max-text-width-amount">
                      ${message.amount}.00
                    </span>
                  </div>
                  <div
                    className={`max-text-width-thanks ${
                      message && message.role === "innovator"
                        ? "green"
                        : message && message.role === "mentor"
                        ? "red"
                        : message && message.role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  >
                    {`THANK YOU @${message.channelid}!`} {"\n"}
                  </div>{" "}
                </div>
              </div>
            </div>
            {user.channelid === profile.channelid && xFalse && (
              <div className="chat-item-notification-containers">
                <div className="chat-notification">
                  <i
                    onClick={() => {
                      removeNotification(notifications, message);
                    }}
                    className={`fas fa-times mx-10 ${
                      message && message.role === "innovator"
                        ? "green"
                        : message && message.role === "mentor"
                        ? "red"
                        : message && message.role === "employer"
                        ? "blue"
                        : ""
                    } cursor`}
                  ></i>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default MessageChatItemMini;
